module.exports = __webpack_public_path__ + "img/1440.0da42bff.jpg";